import React from 'react';
import './Controls.css';
import { translations } from '../translations';

const Controls = ({ isRunning, speed, onStart, onStop, onReset, onSpeedChange, language }) => {
  const t = translations[language];
  
  return (
    <div className="controls">
      <button 
        className="btn start" 
        onClick={onStart}
        disabled={isRunning}
      >
        {t.start}
      </button>
      
      <button 
        className="btn stop" 
        onClick={onStop}
        disabled={!isRunning}
      >
        {t.stop}
      </button>
      
      <button 
        className="btn reset" 
        onClick={onReset}
      >
        {t.reset}
      </button>
      
      <div className="speed-control">
        <label htmlFor="speedSlider">{t.speed}</label>
        <input
          type="range"
          id="speedSlider"
          min="1"
          max="10"
          value={speed}
          onChange={(e) => onSpeedChange(parseInt(e.target.value))}
        />
        <span>{speed}</span>
      </div>
    </div>
  );
};

export default Controls; 